export default __webpack_public_path__ + "static/media/proxima_nova_regular.23ef50ea.ttf";